/**
 * The point `distance` along the line from one point toward another, for a
 * glyph that stops a stroke short of a corner to round it.
 */export default function pointToward(from,to,distance){const length=Math.hypot(to.x-from.x,to.y-from.y);return{x:from.x+(to.x-from.x)*distance/length,y:from.y+(to.y-from.y)*distance/length};}